import { Component, Input, Output, EventEmitter, ViewEncapsulation, OnInit, ViewChildren, QueryList } from '@angular/core';
import { ActionButtonClickTwo, ActionsButtonTableTwo, ColumnsTable, Paginator } from '../../interfaces/basic-table.interface';
import { Table } from 'primeng/table';
import { PrimeNGConfig } from 'primeng/api';
import { FormPrintTwoComponent } from '../form-print-two/form-print-two.component';

@Component({
  selector: 'app-basic-table-two',
  templateUrl: './basic-table-two.component.html',
  styleUrl: './basic-table-two.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class BasicTableTwoComponent implements OnInit {

  isLimitedSelectionActive = false;
  selectionItem: any[] = [];
  expandedRows: { [key: string]: boolean } = {};

  sortOrder: number = -1;
  previousSortField: string | null = null;
  isEnabled = true;

  @ViewChildren('formPrint', { read: FormPrintTwoComponent }) formPrint: QueryList<FormPrintTwoComponent>;

  @Input() minWidth: number = 0;
  @Input() maxSelectedChecks: number = 0;
  @Input() columnsTable: ColumnsTable[] = [];
  @Input() dataTable: any[] = [];
  @Input() actionsTable: ActionsButtonTableTwo[] = [];
  @Input() enableLocalPagination: boolean = false;
  @Input() configPaginator: Paginator | null;
  @Input() configButtonToCheck: { title: string, namebutton: string, icon?: string, color?: string }[] | null = null;
  @Input() isCheckActionBlocked: { disabled: boolean, tooltip?: string } | null = null;
  @Input() configButtonToForm: { title: string, icon?: string } | null = null;
  @Input() tablewithExpasionRow: boolean = false;
  @Input() columnsTableForExpasionRow: ColumnsTable[] = [];
  @Input() nameToPropertySublist: string = '';
  @Input() showCaption: boolean = false;
  @Input() colorearColumna: string[] = [];
  @Input() tableScrollConfig: { height?: string, enabled: boolean } | null = { enabled: false };
  @Output() onClickButtonTable: EventEmitter<ActionButtonClickTwo> = new EventEmitter<ActionButtonClickTwo>();
  @Output() onChangePaginator: EventEmitter<Paginator> = new EventEmitter<Paginator>();
  @Output() onChangeCheckbox: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() onClickButtonToCheck: EventEmitter<void> = new EventEmitter<void>();
  @Output() onClickButtonMassiveForm: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() onFileUpload: EventEmitter<{ files: FileList, rowIndex: number, button: ActionsButtonTableTwo }> = new EventEmitter<{ files: FileList, rowIndex: number, button: ActionsButtonTableTwo }>();
  @Input() set editableRowIndices(value: ActionButtonClickTwo) {
    if (!value && !this.formPrint) return;
    let questions = this.formPrint.toArray()[value.rowIndex]._questions
    questions[0] = { ...questions[0], disabled: false };
    this.formPrint.toArray()[value.rowIndex].questions = questions
  }

  constructor(
    private primengConfig: PrimeNGConfig,
  ) { }

  ngOnInit(): void {
    this.primengConfig.setTranslation({
      startsWith: 'Empieza con',
      contains: 'Contiene',
      notContains: 'No contiene',
      endsWith: 'Termina con',
      equals: 'Igual a',
      notEquals: 'Distinto de',
      noFilter: 'Sin filtro',
      lt: 'Menor que',
      lte: 'Menor o igual que',
      gt: 'Mayor que',
      gte: 'Mayor o igual que',
      is: 'Es',
      isNot: 'No es',
      before: 'Antes de',
      after: 'Después de',
      clear: 'Limpiar',
      apply: 'Aplicar',
      matchAll: 'Coincidir todos',
      matchAny: 'Coincidir cualquiera',
      addRule: 'Agregar regla',
      removeRule: 'Eliminar regla',
    });
  }

  /**
    * @author Ministerio de cultura
    * @createdate 2025-03-03
    * Metodo para selccionar y colorear las columnas de mayor relevancia. 
  */
  getColumnStyle(columna: string) {
    const index = this.colorearColumna.indexOf(columna);
    const colores = ['#F0C32B1A', '#4B3C8C0D'];
    return index !== -1 ? { 'background-color': colores[index] || '#FFF', 'font-weight': '600' } : {};
  }

  /**
    * @author Ministerio de cultura
    * @createdate 2025-03-20
    * Metodo para ordenar las tablas ascendente y descendente 
  */
  setInitialSort(dt: Table, field: string) {
    this.sortOrder = this.previousSortField !== field ? this.sortOrder * -1 : dt.sortOrder * -1;
    this.previousSortField = field;
  }

  getColumnWidth(col: any): string {
    if (col.type === 'action_button') {
      return `${36 * this.actionsTable.length}px`;
    } else if (col.type === 'percentage') {
      return '150px';
    } else {
      return '';
    }
  }

  formatNumber(value: number): string {
    if (value == null) return '';

    const hasDecimals = value % 1 !== 0;
    const format = hasDecimals ? '1.0-2' : '1.0-0';
    return new Intl.NumberFormat('es-CO', {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: 2,
    }).format(value);
  }

  toggleLimitedSelection() {
    if (!this.isLimitedSelectionActive)
      this.selectionItem = [];
    else {
      this.selectionItem = this.dataTable
        .filter(row => !row.isDisabled)
        .slice(0, this.maxSelectedChecks);
    }

    this.onChangeCheckbox.emit(this.selectionItem);
  }

  isCheckboxDisabled(rowData: any): boolean {
    if (this.maxSelectedChecks === 0) return false;
    if (rowData.isDisabled) return true;

    if (this.selectionItem?.length >= this.maxSelectedChecks) {
      return !this.selectionItem.some(item => item.id === rowData.id);
    }

    return false;
  }

  async onChangeField(row: number, $event: any) {
    const { value, key: currentKey, keyValue } = $event as {
      value?: any, key?: string, selectedField?: number, keyValue?: string | { value: number, keyvalue: string }[]
    };
    if (currentKey && this.dataTable[row]) {
      this.dataTable[row][currentKey] = value;
    }

    console.log('onChangeField', $event, row);
    // let { parent, key } = this.coreUtils.getTargetFromPath(this, namePath);
    // parent[key] = this.coreUtils.updateFieldValueByKey(parent[key], currentKey, { value: value });

  }

  onFileSelected(event: any, rowIndex: number, button: ActionsButtonTableTwo) {
    const files = event.target.files;
    if (files && files.length > 0) {
      this.onFileUpload.emit({ files, rowIndex, button });
    }
  }

  onButtonClick(button: ActionsButtonTableTwo, rowData: any, rowIndex: number) {
    if (button.fileInput) {
      const input = document.createElement('input');
      input.type = 'file';
      input.style.display = 'none';
      input.onchange = (event: any) => {
        this.onFileSelected(event, rowIndex, button);
        document.body.removeChild(input);
      };
      document.body.appendChild(input);
      input.click();
    } else {
      this.onClickButtonTable.emit({ data: rowData, button: button, rowIndex: rowIndex });
    }
  }
}
